import Cookies from 'js-cookie';

const form = document.querySelector('.hero-discount-form-wrapper');

if (form) {
    const feedback = form.querySelector('.hero-discount-feedback');
    const result = form.querySelector('.hero-discount-result');
    const promoCodeWrapper = form.querySelector('.hero-discount-promo-code');
    const promoCode = form.querySelector('.hero-discount-promo-code-value');
    const promoDescription = form.querySelector('.hero-discount-promo-description');
    const promoCta = form.querySelector('.hero-discount-promo-cta');
    const spinner = form.querySelector('.hero-discount-spinner');
    const discountForm = form.querySelector('.hero-discount-form');
    const discountFormLabel = form.querySelector('.hero-discount-form-label');
    const { discountId, errorGeneric, errorNetwork } = form.dataset;

    const showResult = (data) => {
        feedback.hidden = true;
        discountForm.hidden = true;
        discountFormLabel.hidden = true;
        if (data.promo_code) {
            promoCode.textContent = data.promo_code;
            promoCodeWrapper.hidden = false;
        } else {
            promoCodeWrapper.hidden = true;
        }
        promoDescription.innerHTML = data.promo_code_description;

        const cta = data.promo_code_cta;
        if (cta?.url) {
            promoCta.href = cta.url;
            promoCta.textContent = cta.title || cta.url;
            promoCta.target = cta.target || '_blank';
            promoCta.hidden = false;
        }

        result.hidden = false;
    };

    const validateMemberNumber = (memberNumber) => {
        spinner.hidden = false;

        fetch(window.ajax_script.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'validate_member_number',
                nonce: window.ajax_script.nonce_discount,
                member_number: memberNumber,
                discount_id: discountId,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success && data.data.is_valid) {
                    Cookies.set('memberNumber', memberNumber);
                    showResult(data.data);
                } else {
                    feedback.textContent = data.data?.message || errorGeneric;
                    feedback.hidden = false;
                }
            })
            .catch(() => {
                feedback.textContent = errorNetwork;
                feedback.hidden = false;
            })
            .finally(() => {
                spinner.hidden = true;
            });
    };

    const savedMemberNumber = Cookies.get('memberNumber');
    if (savedMemberNumber) {
        validateMemberNumber(savedMemberNumber);
    } else {
        discountForm.hidden = false;
        discountFormLabel.hidden = false;
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const memberNumber = form.querySelector('input[name="member_number"]').value.trim();
        validateMemberNumber(memberNumber);
    });
}
